import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "overlay-busy"
}

import { type PropType, computed } from "vue";
import textSpinner from "./TextSpinner.vue";


const __default__ = {
    name: "cool-button",
};

type TextStyleString = "bold" | "";


export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: {
    busySize: Number,
    theme: {
        type: String as PropType<"black" | "turqoise" | "">,
        default: "black",
    },
    size: {
        type: String as PropType<
            | "xx-large"
            | "x-large"
            | "large"
            | "normal"
            | "small"
            | "x-small"
            | "xx-small"
        >,
        default: "normal",
    },
    textStyle: {
        type: [String, Array] as PropType<TextStyleString | TextStyleString[]>,
        default: "bold",
    },
    inline: {
        type: Boolean,
        default: false,
    },
    fullWidth: {
        type: Boolean,
        default: false,
    },
    round: {
        type: Boolean,
        default: false,
    },
    busy: {
        type: Boolean,
        default: false,
    },
    upperCase: {
        type: Boolean,
        default: false,
    },
},
  setup(__props) {

const props = __props;
const styleName = computed(() => {
    if (typeof props.textStyle === "string") return props.textStyle;
    if (Array.isArray(props.textStyle)) return props.textStyle.concat().sort();
    return "none";
});
const classes = computed(() => {
    return [
        "coolButton",
        "theme-" + props.theme,
        "size-" + props.size,
        "style-" + styleName.value,
        props.fullWidth === true ? "option-fullwidth" : "",
        props.inline === true ? "option-inline" : "",
        props.round === true ? "option-round" : "",
        props.busy === true ? "busy-button" : "",
        props.upperCase === true ? "option-uppercase" : "",
    ];
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(classes.value)
  }, [
    _renderSlot(_ctx.$slots, "default"),
    (__props.busy)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(textSpinner, { size: __props.busySize }, null, 8 /* PROPS */, ["size"])
        ]))
      : _createCommentVNode("v-if", true)
  ], 2 /* CLASS */))
}
}

})